export function shouldShowCrackmapMapLoadingOverlay(options: {
  readonly isFetching: boolean;
  readonly hasDisplayedFeatures?: boolean;
}): boolean {
  return options.isFetching;
}
